import { render } from "./AssistantAbout.vue?vue&type=template&id=406006f9&scoped=true"
import script from "./AssistantAbout.vue?vue&type=script&lang=js"
export * from "./AssistantAbout.vue?vue&type=script&lang=js"

import "./AssistantAbout.vue?vue&type=style&index=0&id=406006f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406006f9"]])

export default __exports__